import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import VidsUsersTable from './VidsUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyVidsUsers } from './companyVidsApi';

/**
 * Company Shoorah Videos → Employees/Members list.
 * Every user of the current population appears (those who never watched show
 * dashes and sort last); a row opens their video profile.
 */
const CVidsUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyVidsUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shoorah Videos — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and the videos they have watched. Open a user
        to see their full viewing profile.
      </p>

      <VidsUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/shoorah-videos/user?userId=${rowData?._id}`)}
        tableName="company_vids_users"
      />
    </div>
  );
};

export default CVidsUsers;
